import "./App.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Skills from './pages/Skills';
import SkillDetail from './pages/SkillDetail';
import Experience from './pages/Experience';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProjectDisplay from "./pages/ProjectDisplay";
import { LanguageProvider } from './context/LanguageContext';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <LanguageProvider>
          <Router>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="project/:id" element={<ProjectDisplay />} />
              <Route path="/skills" element={<Skills />} />
              <Route path="/skills/:slug" element={<SkillDetail />} />
              <Route path="/experience" element={<Experience />} />
            </Routes>
            <Footer />
          </Router>
        </LanguageProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
